import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a010510e")

_pushScopeId("data-v-a010510e")
const _hoisted_1 = { class: "text-gray-333 basic-flow-create-container" }
const _hoisted_2 = { class: "mb-8" }
const _hoisted_3 = { class: "font-bold font-size-24 mb-4" }
const _hoisted_4 = { class: "whitespace-no-wrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_PersonalFlowElement = _resolveComponent("PersonalFlowElement")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_BackPreviousPage, { onClick: _ctx.backPersonalFlowSettingsList }, null, 8, ["onClick"]),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('personalFlowSetting.individualSetting')) + "： " + _toDisplayString(_ctx.unitName), 1),
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.t('personalFlowSetting.descCreate')), 1)
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataStore, (item, index) => {
      return (_openBlock(), _createBlock(_component_PersonalFlowElement, {
        data: item,
        parentKey: index,
        key: index,
        listEmployee: _ctx.employeeList,
        listRole: _ctx.roleData
      }, null, 8, ["data", "parentKey", "listEmployee", "listRole"]))
    }), 128))
  ]))
})